import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import style from "./Header.module.css";
import logo from "../../assets/pc-engine.svg"

const Header = () => {
  const [fixed, setFixed] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 250) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    });
  });
  return (
    <div className={`header ${fixed && "fixedNav"}`}>
      <div className={style.container}>
        <div className={style.header__inner}>
          <div className={style.logo}>
            <NavLink to="/"><img className={style.logo} src={logo} alt="" /></NavLink>
          </div>

          <div className={style.nav}>
            <NavLink to="/Home">Home</NavLink>
            <NavLink to="/Shop">Shop</NavLink>
            <NavLink to="/Upgrade">Upgrade</NavLink>
            <NavLink to="/Configure">Configure</NavLink>
            <NavLink to="/News">News</NavLink>
            <NavLink to="/Aboutus">About us</NavLink>
          </div>
          <div className={style.nav__right}>

            <NavLink to="/Cart"><span className="material-symbols-outlined">
              shopping_cart
            </span></NavLink>
            <NavLink to="/MainProfile"><span className="material-symbols-outlined">
              account_circle
            </span></NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
